<bzg-modal-header>
    <span class="bz-modal__title">{{'RPA_BOTS.SELECTBOTDEVICE' | translate }}</span>
    <bzg-button-icon [icon]="'icon-close'" [bzgModalClose]="{trigger: 'close'}">
    </bzg-button-icon>
</bzg-modal-header>
<bzg-modal-content>
    <div class="bmc-bot-configuration">
        <form #botConfigForm="ngForm">
            <div *ngIf="availableUsers && !isVersion11_3()" class="bmc-bot-configuration__content-table bz-space--stack-m">
                <h5 class="bmc-bot-configuration__list__subtitle bz-font-weight--semibold">
                    {{ 'RPA_BOTS.AVAILABLEUSERS' | translate }}
                </h5>
                <table class="bz-table">
                    <thead>
                        <tr>
                            <th class="bz-table__cell--sortable bmc-bot-configuration__cell-left">

                            </th>
                            <th class="bz-table__cell--sortable">
                                {{ 'GLOBAL.USER_NAME' | translate }}
                            </th>
                            <th class="bz-table__cell--sortable">
                                {{ 'RPA_BOTS.FIRST_NAME' | translate }}
                            </th>
                            <th class="bz-table__cell--sortable">
                                {{ 'RPA_BOTS.LAST_NAME' | translate }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let userAae of availableUsers">
                            <td class="bmc-bot-configuration__table__cell__check">
                                <bzg-radio-button name="radiogroup" [checked]="userAae.id == selectedUserOption" (click)="setSelectedUser(userAae.id)"></bzg-radio-button>
                            </td>
                            <td class="bmc-bot-configuration__table__cell">
                                <div class="bmc-bot-configuration__avatar-container">

                                    {{ userAae.username }}
                                </div>
                            </td>
                            <td class="bmc-bot-configuration__table__cell">
                                <div class="bmc-bot-configuration__avatar-container">

                                    {{ userAae.firstName }}
                                </div>
                            </td>
                            <td class="bmc-bot-configuration__table__cell">
                                <div class="bmc-bot-configuration__avatar-container">

                                    {{ userAae.lastName }}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="!isVersion11_3()">
                <bz-loading [size]="'m'" *ngIf="(isLoadingUsers$ | async)">
                    {{ 'GLOBAL.LOADING_DATA' | translate }}</bz-loading>
            </div>

            <div *ngIf="availableBots" class="bmc-bot-configuration__content-list">
                <h5 class="bmc-bot-configuration__list__title bz-font-weight--semibold">
                    {{ 'RPA_BOTS.AVAILABLEBOTS' | translate }}
                </h5>
                <bzg-select class="bmc-bot-configuration__select" [placeholder]="'RPA_BOTS.SELECTBOT' | translate" [(value)]="selectedBotOption" (valueChange)="setSelectedBot($event)">
                    <bzg-option *ngFor="let itemBots of availableBots" [value]="itemBots.id">
                        {{itemBots.name}}
                    </bzg-option>
                </bzg-select>
            </div>
            <div *ngIf="availableDevices  && isVersion11_3()" class="bmc-bot-configuration__content-table">
                <h5 class="bmc-bot-configuration__list__subtitle bz-font-weight--semibold">
                    {{ 'RPA_BOTS.AVAILABLEDEVICES' | translate }}
                </h5>
                <table class="bz-table">
                    <thead>
                        <tr>
                            <th class="bz-table__cell--sortable bmc-bot-configuration__cell-left">

                            </th>
                            <th class="bz-table__cell--sortable">
                                {{ 'GLOBAL.USER_NAME' | translate }}
                            </th>
                            <th class="bz-table__cell--sortable">
                                {{ 'GLOBAL.NAME' | translate }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let device of availableDevices">
                            <td class="bmc-bot-configuration__table__cell__check">
                                <bzg-radio-button [checked]="device.id == selectedDeviceOption" (change)="setSelectedDevice(device)"></bzg-radio-button>
                            </td>
                            <td class="bmc-bot-configuration__table__cell">
                                <div class="bmc-bot-configuration__avatar-container">

                                    {{ device.userName }}
                                </div>
                            </td>
                            <td class="bmc-bot-configuration__table__cell">
                                <div class="bmc-bot-configuration__avatar-container">

                                    {{ device.name }}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="availablePoolDevices && !isVersion11_3()" class="bmc-bot-configuration__content-table">
                <h5 class="bmc-bot-configuration__list__subtitle bz-font-weight--semibold">
                    {{ 'RPA_BOTS.AVAILABLEPOOLDEVICES' | translate }}
                </h5>
                <table class="bz-table">
                    <thead class="bz-space--stack-s">
                        <tr>
                            <th class="bz-table__cell--sortable bmc-bot-configuration__cell-left">

                            </th>
                            <th class="bz-table__cell--sortable">
                                {{ 'RPA_BOTS.NAME' | translate }}
                            </th>
                            <th class="bz-table__cell--sortable">
                                {{ 'RPA_BOTS.STATUS' | translate }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let poolDevice of listPoolDevices; let i = index">
                            <td class="bmc-bot-configuration__table__cell__check bz-space--inset-xs">
                                <div class="bz-checkbox">
                                    <bzg-checkbox id="{{i}}" (change)="setSelectedPoolDevices(poolDevice,$event)" [checked]="poolDevice.checked">
                                    </bzg-checkbox>
                                </div>
                            </td>
                            <td class="bmc-bot-configuration__table__cell bz-space--inset-xs">
                                <div class="bmc-bot-configuration__avatar-container">
                                    {{ poolDevice.name }}
                                </div>
                            </td>
                            <td class="bmc-bot-configuration__table__cell bz-space--inset-xs">
                                <div class="bmc-bot-configuration__avatar-container">

                                    {{ poolDevice.status }}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="!isVersion11_3()">
                <bz-loading [size]="'m'" *ngIf="(isLoadingPoolDevices$ | async)">
                    {{ 'GLOBAL.LOADING_DATA' | translate }}</bz-loading>
            </div>
            <div *ngIf="isVersion11_3()">
                <bz-loading [size]="'m'" *ngIf=" (isLoadingDevices$ | async)">
                    {{ 'GLOBAL.LOADING_DATA' | translate }}</bz-loading>
            </div>
            <div *ngIf="!isVersion11_3()" class="bmc-bot-configuration__check bz-flex bz-space--inline-l">
                <div class="bz-checkbox">
                    <bzg-checkbox (change)="setSelectedOverrideDefaultDevice($event)" [checked]="selectedOverrideDefaultDeviceOption">
                        {{'RPA_BOTS.OVERRIDE_DEFAULT_DEVICE' | translate}}
                    </bzg-checkbox>
                </div>
            </div>
            <div *ngIf="process" class="bmc-bot-configuration__check bz-flex bz-space--inline-l">
                <div class="bz-checkbox">
                    <bzg-checkbox [disabled]="true" id="fireAndForget" [checked]="process.isFireAndForget">
                        {{'RPA_BOTS.FIREANDFORGET' | translate}}
                    </bzg-checkbox>
                </div>
            </div>
        </form>
    </div>
</bzg-modal-content>
<bzg-modal-footer>
    <bzg-button-secondary class="bz-space--inline-m" [bzgModalClose]="{trigger: 'close'}">
        {{'GLOBAL.CANCEL' | translate }}</bzg-button-secondary>
    <bzg-button-primary (click)="saveProcess()">{{'GLOBAL.APPLY' | translate }}
    </bzg-button-primary>
</bzg-modal-footer>